/* SENSORIAL sc-buybar.js — barra de compra fija de la ficha de producto.
 *
 * Tres cosas y ninguna más:
 *   1. enseñarla cuando se ha bajado el umbral (150vh por defecto),
 *   2. mantenerla pegada a la VARIANTE SELECCIONADA en la ficha,
 *   3. añadir al carrito con la cantidad que ponga su contador.
 *
 * Lo de la variante no es un detalle: si la barra añadiera siempre la primera, un cliente
 * que ha elegido 1 kg molido se llevaría 250 g en grano sin enterarse. Por eso lee el
 * input `name="id"` del formulario de la ficha, que es el que el tema mantiene al día.
 *
 * El scroll se mide sobre .page-wrapper, que es el contenedor que scrollea en este tema;
 * window.scrollY se queda a cero y la barra no aparecería nunca.
 */
(function () {
  'use strict';

  var barra = document.querySelector('[data-sc-buybar]');
  if (!barra) return;

  var scroller = document.querySelector('.page-wrapper') || document.scrollingElement || document.documentElement;
  var umbralVh = parseInt(barra.getAttribute('data-sc-buybar-umbral'), 10) || 150;

  var elPrecio = barra.querySelector('[data-sc-buybar-precio]');
  var elCantidad = barra.querySelector('[data-sc-buybar-cantidad]');
  var elAnadir = barra.querySelector('[data-sc-buybar-anadir]');

  var precios = {};
  var json = barra.querySelector('[data-sc-buybar-precios]');
  if (json) {
    try { precios = JSON.parse(json.textContent); } catch (e) { precios = {}; }
  }

  function inputVariante() {
    // El formulario de la ficha. Se busca cada vez porque el tema lo vuelve a pintar al
    // cambiar de variante y una referencia guardada se quedaría apuntando a un nodo muerto.
    var inputs = document.querySelectorAll('form[action*="/cart/add"] [name="id"]');
    for (var i = 0; i < inputs.length; i++) {
      if (!barra.contains(inputs[i])) return inputs[i];
    }
    return null;
  }

  function varianteActual() {
    var input = inputVariante();
    var id = input && input.value;
    return id || elAnadir.getAttribute('data-variante');
  }

  function refrescarPrecio() {
    var id = varianteActual();
    if (!id || !precios[id] || !elPrecio) return;
    // La comparacion NO sobra. Escribir textContent reemplaza el nodo de texto, y eso es
    // una mutacion del DOM: con un MutationObserver escuchando, cada refresco se
    // disparaba a si mismo y la pestana se quedaba colgada. Asi solo se escribe cuando el
    // precio cambia de verdad, y la cadena se corta.
    if (elPrecio.textContent === precios[id]) return;
    elPrecio.textContent = precios[id];
  }

  // ---- mostrar y esconder -----------------------------------------------------------
  var visible = false;
  function revisar() {
    var bajado = (scroller.scrollTop || window.scrollY || 0) > (window.innerHeight * umbralVh) / 100;
    if (bajado === visible) return;
    visible = bajado;
    barra.hidden = !bajado;
    // La clase va en un frame aparte: aplicarla a la vez que se quita [hidden] no anima,
    // porque el elemento pasa de display:none a su posición final sin estado intermedio.
    if (bajado) requestAnimationFrame(function () { barra.classList.add('is-visible'); });
    else barra.classList.remove('is-visible');
  }

  var pendiente = false;
  function alScroll() {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(function () { pendiente = false; revisar(); });
  }

  scroller.addEventListener('scroll', alScroll, { passive: true });
  window.addEventListener('scroll', alScroll, { passive: true });
  window.addEventListener('resize', alScroll, { passive: true });
  revisar();

  // ---- cantidad ---------------------------------------------------------------------
  function cantidad() {
    var n = parseInt(elCantidad && elCantidad.value, 10);
    return n > 0 ? n : 1;
  }

  barra.addEventListener('click', function (ev) {
    var menos = ev.target.closest('[data-sc-buybar-menos]');
    var mas = ev.target.closest('[data-sc-buybar-mas]');
    if (!menos && !mas) return;
    ev.preventDefault();
    elCantidad.value = Math.max(1, cantidad() + (mas ? 1 : -1));
  });

  // ---- variante ---------------------------------------------------------------------
  document.addEventListener('change', function (ev) {
    if (ev.target && ev.target.name === 'id') refrescarPrecio();
  });
  // El tema cambia la variante repintando el formulario, sin lanzar 'change'. Mirar el DOM
  // es lo unico que se entera de eso, PERO no se mira el <body> entero: en esta pagina hay
  // mucha actividad ajena (el widget de Shop, el cajon del carrito, las secciones que se
  // repintan solas) y observarlo todo era pagar un repaso por cada una de esas mutaciones.
  // Se observa solo la zona del formulario, y ademas se agrupa con requestAnimationFrame.
  var zona = document.querySelector('form[action*="/cart/add"]');
  zona = (zona && zona.closest('.product-details, product-form-component, .product-information')) || zona;
  if (zona && !zona.contains(barra)) {
    var repasoPendiente = false;
    var observador = new MutationObserver(function () {
      if (repasoPendiente) return;
      repasoPendiente = true;
      requestAnimationFrame(function () { repasoPendiente = false; refrescarPrecio(); });
    });
    observador.observe(zona, { subtree: true, childList: true });
  }
  refrescarPrecio();

  // ---- añadir al carrito ------------------------------------------------------------
  elAnadir.addEventListener('click', function () {
    var id = varianteActual();
    if (!id) return;
    var texto = elAnadir.textContent;
    elAnadir.disabled = true;
    elAnadir.textContent = '···';

    var lineas = [{ id: Number(id), quantity: cantidad() }];
    var promesa;
    if (window.scCarrito && typeof window.scCarrito.anadir === 'function') {
      promesa = window.scCarrito.anadir(lineas, 'sc-buybar');
    } else {
      promesa = fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: lineas })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Error'); });
        return r.json();
      });
    }

    promesa
      .catch(function () {})
      .then(function () {
        elAnadir.disabled = false;
        elAnadir.textContent = texto;
      });
  });
})();
